import { FC, ReactElement } from 'react'
import { ReactComponent as CogIcon } from '../../assets/icons/cog.svg'
import { ReactComponent as MoneyIcon } from '../../assets/icons/money2.svg'
import { ReactComponent as PatientsIcon } from '../../assets/icons/patients.svg'
import { ReactComponent as ProcessExamIcon } from '../../assets/icons/process-exam.svg'
import { ReactComponent as ProfileIcon } from '../../assets/icons/profile.svg'
import Footer from '../../components/footer'
import LoggedNavigation from '../../components/loggedNavigation'
import SideNavigation, { SideNavigationItem, SideNavigationMenu } from '../../components/sideNavigation'
import { RoutesEnum } from '../../utils/routesEnum'
import { Container } from './style'

type LoggedAreaProps = {
  navigationComponent?: ReactElement
}

const LoggedArea: FC<LoggedAreaProps> = ({ children, navigationComponent }): ReactElement => {
  return (
    <>
      <LoggedNavigation />
      <Container>
        <div className='navigation'>
          <SideNavigation key='side-navigation'>
            <SideNavigationMenu name='process-exam' isDefaultOpened title='Processar Exames' icon={<ProcessExamIcon />}>
              <SideNavigationItem to={RoutesEnum.PROCESS_EXAMS}>
                Inserir Exame
              </SideNavigationItem>
              {/* <SideNavigationItem>
                Histórico Exames
              </SideNavigationItem> */}
            </SideNavigationMenu>
            <SideNavigationMenu name='patients' title='Pacientes' icon={<PatientsIcon />}>
              <SideNavigationItem to={RoutesEnum.PATIENTS}>
                Meus Pacientes
              </SideNavigationItem>
              <SideNavigationItem to={RoutesEnum.PATIENTS_CREATE}>
                Inserir Paciente
              </SideNavigationItem>
            </SideNavigationMenu>
            <SideNavigationMenu name='profile' title='Perfil' icon={<ProfileIcon />}>
              <SideNavigationItem to={RoutesEnum.PROFILE}>
                Meu perfil
              </SideNavigationItem>
            </SideNavigationMenu>
            <SideNavigationMenu name='subscription' title='Assinatura' icon={<MoneyIcon />}>
              <SideNavigationItem to={RoutesEnum.SUBSCRIPTION}>
                Minha assinatura
              </SideNavigationItem>
            </SideNavigationMenu>
            <SideNavigationMenu name='help' title='Ajuda e Suporte' icon={<CogIcon />}>
              <SideNavigationItem to={RoutesEnum.FAQ}>
                F.A.Q.
              </SideNavigationItem>
              <SideNavigationItem to={RoutesEnum.CONTACT}>
                Ajuda
              </SideNavigationItem>
            </SideNavigationMenu>
          </SideNavigation>
          {navigationComponent}
        </div>
        <div className='content'>
          {children}
        </div>
      </Container>
      <Footer />
    </>
  )
}

export default LoggedArea
